import { CheckCircleOutlineRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSignatureByMeetingIdRequest } from '../../services/requests/assinaturas/utils';
import useMinuteStore from '../../store/minute';
import { Container } from './styles';

export const SuccessPageSignature = () => {
  const params = useParams();
  const setMinute = useMinuteStore(state => state.setMinute);
  const minute = useMinuteStore(state => state.minute);
  const [authorizationCode, setAuthorizationCode] = useState<string | null>();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    setAuthorizationCode(code);
  }, [authorizationCode]);

  useEffect(() => {
    if (authorizationCode) {
      window.opener.postMessage({ authorizationCode });
    }
  }, [authorizationCode]);

  useEffect(() => {
    async function handleSignatures() {
      const response = await getSignatureByMeetingIdRequest(
        params?.id as string,
      );

      if (response?.status === 200) {
        setMinute({
          ...minute,
          status: 'CS2',
        });
      }
    }

    if (params?.id) {
      handleSignatures();
    }
  }, [params, setMinute]);

  return (
    <Box width="100vw" height="100vh" padding="20px">
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        gap="10px"
        height="90%"
        justifyContent="center"
      >
        <CheckCircleOutlineRounded
          color="success"
          sx={{ width: '66px', height: '66px' }}
        />
        <Container display="flex" flexDirection="column">
          <span className="title">Assinatura solicitada com sucesso!</span>
        </Container>
      </Box>
    </Box>
  );
};
